import React from 'react'
import '../styles/index.scss'
import JobDetailPage from './JobDetailPage'

function JobDetailContainer(props) {
    const jobId = props.match.params.id
    return (
        <div className='JobDetailContainer'>
            <JobDetailPage jobId={jobId} />
        </div>
    )
}

export default JobDetailContainer